import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import RippleLink from './Forms/RippleLink';

export const LoginRequiredPage = (props) => {
  const {
    loginWithRedirect,
    isLoading,
  } = useAuth0();

  const sdkRedirectUrl = `${window.location.origin}${window.location.pathname}`;
  const authRedirectUrl = props.config.authRedirectUri || sdkRedirectUrl;
  const auth0ClientId = props.config.auth0ClientId || '';
  const authAudience = props.config.authAudience;
  const authResponseType = props.config.authResponseType || 'code';
  const authScope = props.config.authScope || 'openid profile';
  const authAuthorizeHost = props.config.authAuthorizeHost || props.config.authHost;
  const authState = 'F5F23CB3-F000-4365-A937-2C3806289F7B';
  const authUrl = `${authAuthorizeHost}/authorize` +
      `?response_type=${encodeURIComponent(authResponseType)}` +
      `&client_id=${auth0ClientId}` +
      `&redirect_uri=${encodeURIComponent(authRedirectUrl)}` +
      `&scope=${encodeURIComponent(authScope)}` +
      `&prompt=${encodeURIComponent('login')}` +
      `${authAudience ? `&audience=${encodeURIComponent(authAudience)}` : ''}` +
      `&state=${encodeURIComponent(authState)}`;

  const onLoginClick = async (event) => {
    event.preventDefault();

    if (!loginWithRedirect || isLoading) {
      window.location.href = authUrl;
      return;
    }

    const authorizationParams = {
      redirect_uri: sdkRedirectUrl,
      scope: authScope,
      prompt: 'login',
    };

    if (authAudience) {
      authorizationParams.audience = authAudience;
    }

    await loginWithRedirect({ authorizationParams });
  };

  return (
    <div className="main">
      <div id="unauthorized" className="page">
        <section>
          <h1>Transfer Funds</h1>
          <p>For additional security, please verify your credentials by logging in again.</p>
          <div className="actions">
            <RippleLink
              to={authUrl}
              target="_top"
              onClick={onLoginClick}
            >
                Login
            </RippleLink>
          </div>
          {props.config.showDemoLogin &&
          <div>
            <br />
            <p>Don&#39;t have an account? No problem.</p>
            <a href="?access_token=1234&amp;client_id=demo" alt="demo login" id="demo-login">Demo Login</a>
          </div>
          }
        </section>
      </div>
    </div>
  );
};

LoginRequiredPage.propTypes = {
  config: PropTypes.shape({
    showDemoLogin: PropTypes.bool,
    authHost: PropTypes.string,
    authAuthorizeHost: PropTypes.string,
    authRedirectUri: PropTypes.string,
    authAudience: PropTypes.string,
    authResponseType: PropTypes.string,
    authScope: PropTypes.string,
    auth0ClientId: PropTypes.string,
  }),
};

const page = connect(
  (state) => {
    return {
      config: state.configuration,
    };
  }
)(LoginRequiredPage);

export default page;
